module.exports = __webpack_public_path__ + "static/media/btnAddTimeStamp.5d773ad5.svg";